import { CSSProperties, ReactNode, Ref } from "react";
import "./styles.css";

export function TableFilterRow({
  children,
  hidden,
}: {
  children: ReactNode;
  hidden?: boolean;
}) {
  return (
    <div className="filter__content" hidden={hidden}>
      {children}
    </div>
  );
}

export function TableViewport({
  children,
  loading = false,
  containerRef,
  containerStyle,
  ariaLabel,
}: {
  children: ReactNode;
  loading?: boolean;
  containerRef?: Ref<HTMLDivElement>;
  containerStyle?: CSSProperties;
  ariaLabel?: string;
}) {
  return (
    <div
      className="tableContainer__wrapper"
      role={ariaLabel ? "region" : undefined}
      aria-label={ariaLabel}
    >
      {loading && (
        <div className="tableContainer__loading-overlay">
          <div className="lds-ring">
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className="tableContainer" ref={containerRef} style={containerStyle}>
        {children}
      </div>
    </div>
  );
}
